/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const Environment = zod
	.object({
		id: zod.string().describe('Environment ID'),
		inserted_at: zod.iso.datetime({ offset: true }).describe('Creation timestamp'),
		name: zod.string().describe('Environment name'),
		organization_id: zod.string().describe('Organization ID'),
		signing_secret: zod
			.string()
			.describe('Secret used to verify praetoid-signature callback headers'),
		type: zod.enum(['production', 'sandbox']),
		updated_at: zod.iso.datetime({ offset: true }).describe('Last update timestamp')
	})
	.describe('An environment configuration');

export type Environment = zod.input<typeof Environment>;
export type EnvironmentOutput = zod.output<typeof Environment>;
